import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { buildRecentProfileMatches } from "./profileRecentMatches";
import ProfileMatchesTable from "./ProfileMatchesTable";
import { ProfileMatchRowsSkeleton } from "./profileSkeletons";

export default function OverviewRecentMatchesTable({
    last25MatchData = {},
    isLoading = false,
}) {
    const matches = useMemo(
        () => buildRecentProfileMatches(last25MatchData, 5),
        [last25MatchData]
    );

    if (isLoading) {
        return <ProfileMatchRowsSkeleton count={5} />;
    }

    return <ProfileMatchesTable matches={matches} showAdr={false} />;
}

OverviewRecentMatchesTable.propTypes = {
    last25MatchData: PropTypes.object,
    isLoading: PropTypes.bool,
};
